<template>
  <div>
    <status-history :history-items="historyItems" :bordered="bordered">
      <slot></slot>
    </status-history>

    <pagination
      v-if="paginationModel.totalItemCount > paginationModel.perPage"
      :data="paginationModel"
      show-text
      @pagination-go-page="fetchHistoryData($event)"
    />
  </div>
</template>

<script>
import Pagination from 'pagination'
import StatusHistory from './StatusHistory.vue'
import Service from "@/services/api/edendisputeResolution.api";

export default {
  name: 'StatusHistoryTab',
  components: {
    Pagination,
    StatusHistory,
  },
  props: {
    edenId: {
      type: Number,
      required: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      historyItems: [],
      paginationModel: {
        perPage: 5,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0,
      },
    };
  },
  async mounted() {
    await this.fetchHistoryData();
  },
  methods: {
    async fetchHistoryData(pageIndex = 1) {      
      this.paginationModel.currentPage = pageIndex

      const { data } = await Service.getHistory(
        this.edenId,
        this.paginationModel.currentPage,
        this.paginationModel.perPage);
        
      this.historyItems = [...data.data];
      this.paginationModel.totalItemCount = data.totalItemCount;
      this.paginationModel.pageCount = data.pageCount;
      this.paginationModel.count = data.count;
    },
  },
};
</script>

<style scoped>
</style>
